var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 20.7498C15.8003 20.7508 15.6092 20.6715 15.4693 20.5298L7.46934 12.5298C7.17689 12.237 7.17689 11.7627 7.46934 11.4698L15.4693 3.46985C15.7648 3.19449 16.2253 3.20261 16.511 3.48823C16.7966 3.77384 16.8047 4.23434 16.5293 4.52985L9.05934 11.9998L16.5293 19.4698C16.8218 19.7627 16.8218 20.237 16.5293 20.5298C16.3895 20.6715 16.1984 20.7508 15.9993 20.7498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.1f6cca6305ba7584f63b5bf9579c24ac.svg";
export { ForwardRef as ReactComponent };